import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Location, ViewportScroller } from '@angular/common';
import { InventoryService } from 'app/services/inventory.service';
import { GlobalSearchService } from 'app/services/globalsearchservice.service';
import { OrdersService } from 'app/services/orders.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormControl } from '@angular/forms';
import { UsersService } from 'app/services/users.service';
import { OmsService } from 'app/services/oms.service';
import { DispatchService } from 'app/services/dispatch.service';
import { GlobalsService } from 'app/services/globals.service';


@Component({
	selector: 'app-sticker-scan-out',
	templateUrl: './sticker-scan-out.component.html',
	styleUrls: ['./sticker-scan-out.component.scss']
})

export class StickerScanOutComponent implements OnInit {
	view: any = '';
	config: any = false;
	user: any = false;
	color: any = 'blue';
	displayedt: any = false;
	skuSearchRef = new UntypedFormControl(''); 	//1 -landing ref
	labelScanRef = new UntypedFormControl(''); 	//2 -order selection
	fedexScanRef = new UntypedFormControl(''); 	//3 -validating order
	itemScanRef = new UntypedFormControl(''); 	//4 -item scan to print and mark pack
	stageScanRef = new UntypedFormControl('');  //used in staging mode
	historySearchRef = new UntypedFormControl(''); //modal
	containerRef = new UntypedFormControl(''); //modal
	@ViewChild('searchRef') searchRef!: ElementRef;
	@ViewChild('mainContent') mainContent!: ElementRef;

	pickups: any = false;
	signing = {
		status: false,
		value: false
	}

	hasError = false;

	//holds items listing of orders for selection
	availableOrders: any = [];
	availableOrdersFiltered: any = [];
	
	//array to hold order selections prior to sending to socket
	stagedOrders = [];

	stageMode = false;

	//holds sku data
	currentProduct: any = false;
	
	//sku search and load subs
	searchsub: any = false;
	skusub: any = false;

	//used when barcode/sku search comes back with multiple
	showSkuTable: any = false;
	availableSkus: any = [];
	lastSearchedCode: any = false;

	//order to confirm with fedex label scan
	orderToConfirm: any = false
	//label to print - 3rd step
	labelToPrint: any = false;

	packedStatus = '25';
	stagedStatus = '24';
	currentstep = 'TIRE';

	pickupcount: any = 0;
	lastStaged: any = false;
	lastPacked: any = false;
	
	currentCounts: any = false;
	errorMsg: any = false;

	ocing: any = false;
	showHistory = false;
	batchHistory: any = false;
	batchHistoryFiltered: any = false;
	historymatches: any = [];
	
	isKeyboardOpen = false;	  
	@ViewChild('reprintModal') reprintModalRef: ElementRef;
	@ViewChild('scanTypeModal') scantypeModalRef: ElementRef;
	@ViewChild('containerAddModal') containerAddModalRef: ElementRef;

	@ViewChild('ocAlertModal') ocAlertModal: ElementRef;
	userocdata: any = false;
	picking: any = false;
	stickershipvias: any = false;

	packedlabels: any = false;
	typeselected: any = false;
	allshipvias: any = false;
	scanouttypes: any = false;

	stagingType: any = false;
	showContainerSelection: any = false;
	shipperContainers: any = [];
	activeStageType: any = false;
	dashboardStaged: any = [];
	activeOc: any = false;
	showFilter = false;

	orderTypes = [
		{ view : 'RTS', value: 25 },
		{ view : 'LOADED', value: 24 }
	];
	shipperTypes: any = false;
	
	ordTypeFilter = new UntypedFormControl('all');
	shipperTypeFilter = new UntypedFormControl('all');
	stagedOrdersAll: any = false;
	stagetypeset = false;
	orderInfo: any = false;
	mainprinter = false;
	enableAdminControls = false;
	alltrksload = false;

	adminStatusRef = new UntypedFormControl(0);
	clicktoload = false;

	allTrackingToLoadRef = new UntypedFormControl(0); //need to store in db
	loadingOrder: any = false;

	constructor(private globalsService: GlobalsService, private viewportScroller: ViewportScroller,private location: Location, public inventoryService: InventoryService, private globalSearchService: GlobalSearchService, public ordersService: OrdersService, private modalService: NgbModal, private usersService: UsersService, private omsService: OmsService, private dispatchService: DispatchService) {
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
			this.globalSearchService.user.subscribe(u => {
				this.user = u;
				this.view = u.user.userid === 'TVGUIDE' ? 'dashboard' : 'user';
				if(['1', '25', '22'].includes(this.user.user.user_group)){
					this.enableAdminControls = true;
					if(window.innerWidth > 900){
						this.view = 'dashboard';
					}
				}
			})
		});
		this.color = this.globalSearchService.getColor();
		const listener = () => {
			const MIN_KEYBOARD_HEIGHT = 300 // N.B.! this might not always be correct
			const isMobile = window.innerWidth < 768
			this.isKeyboardOpen = isMobile && window.screen.height - MIN_KEYBOARD_HEIGHT > window.visualViewport.height
		  }
		window.visualViewport.addEventListener('resize', listener)

	}

	ngOnInit(): void {
		this.getLastOrders()
		this.startSocketListener();
		this.getStickerShipvias();
		this.getConfiguration();
		this.initUser();

		this.ordTypeFilter.valueChanges.subscribe((newV) => {
			this.filterOrders();
		})

		this.shipperTypeFilter.valueChanges.subscribe((newV) => {
			this.filterOrders();
		})

		this.adminStatusRef.valueChanges.subscribe((newV) => {
			this.clicktoload = newV;
		})

		this.allTrackingToLoadRef.valueChanges.subscribe((newV) => {
			if(this.alltrksload !== newV){
				this.alltrksload = newV;
				this.updateConfig('allTracksToLoad');
			}
		})
	}

	getConfiguration(){
		this.inventoryService.getScanOutConfig().subscribe((res: any) => {
			this.packedlabels = res.packedlabels; //db config flag for printing internal package labels
			this.mainprinter = res.mainprinter;
			
			//global config to require all tracking # to be scanned to load an order
			this.alltrksload = res.trackingtoload;
			this.allTrackingToLoadRef.setValue(this.alltrksload);
		})
	}

	updateConfig(type){
		if(type === 'allTracksToLoad'){
			const data = { 'confname' : 'trackingtoload', 'confvalue': this.alltrksload ? 1 : 0 }
			this.inventoryService.updateScanOutConfig(data).subscribe((res: any) => {
				if(res.success){
					this.getConfiguration();
					this.sendScanSocket({}, 'config-update');
				}
			})
		}
	}

	changeView(view){
		this.view = view == 'dashboard' ? 'user' : 'dashboard'; 
		if(this.view == 'dashboard'){
			this.unitsStaged()
			this.getLastOrders();
			this.formatDashboardStaged();
		}
	}

	async openTypeSelection(){
		this.activeStageType = false;
		await this.getStickerShipvias();

		this.modalService.open(this.scantypeModalRef, { ariaLabelledBy: 'modal-basic-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {
			if(!this.activeStageType || !this.stagetypeset){
				this.stageMode = false;
				this.currentstep = 'TIRE';
			}
		});
	}



	//initialize order listing for user view
	initUser() {
		this.ordersService.getPackedStickerOrders().subscribe((res: any) => {
			const shipperTypes = [];
			const temp = [];
			res.forEach(order => {
				temp.push(order.so[0]);
			});
			
			this.stagedOrders = temp;
			this.stagedOrdersAll = temp;
			
			if(this.view === 'dashboard'){
				this.formatDashboardStaged();
			}

			this.unitsStaged();
		})
	 }

	 //gets latest stage and packed ord
	 getLastOrders(){
		this.ordersService.getLastStickerOrders().subscribe((res: any) => {
			this.lastStaged = res.staged;
			this.lastPacked = res.packed
		});
	 }


	 //enters stagemode - packed -> rts  or rts -> packed here
	 toggleStageMode(){
		this.stageMode = !this.stageMode;
		if(this.stageMode){
			this.openTypeSelection();
			this.stagedOrders.map((ord) => {
				if(ord.status == '25'){
					ord.tracking.forEach(trk => {
						trk.confirmed = false;
					});
				}
			})
			this.currentstep = 'ORDER STAGING'
		}else{
			this.activeStageType = false;
			this.initUser();
			this.currentstep = 'TIRE';
		}
	 }

	//get listing of open orders by sku
	orderSearch() {
		if(this.searchsub){
			this.searchsub = false;
		}  
		
		const search = this.skuSearchRef.value.trim();
		this.lastSearchedCode = search;
		this.skuSearchRef.setValue('');
		this.currentProduct = false;

		//get listing of stockids by barcode or - stockid if not assigned one yet
		this.searchsub = this.inventoryService.itemSearch({ stockid:search, type:['stickerscanout'] }).subscribe((results: any) => {
			this.searchsub = false;
			
			if(results.length == 1){ //one to one match - load for selection
				const sku = results[0];
				this.loadItem(sku.stockid);
			}else{
				this.showSkuTable = true;
				this.availableSkus = results;
				if(!this.availableSkus.length){
					this.focusInput();
				}
			}
		});

	 }

	//details of item
	loadItem(stockid){
		if(this.skusub){
			this.skusub = false;
		}

		this.availableOrders = [];

		this.currentProduct = false;
		this.skusub = this.inventoryService.loadStickerItem(stockid).subscribe((result: any) => {
			this.skusub = false;
			this.showSkuTable = false;
			this.currentstep = 'ORDER'
			this.currentProduct = result.item;
			this.scrollToTop();
			
			if(result.salesordersdetails && result.salesordersdetails.length){
				this.currentProduct.hasOrders = true;
				this.buildAvailableOrders(result);
			}else{
				this.currentProduct.hasOrders = false;
			}
			
		})
	}


	//takes result of open orders from loaditem and compares it to stagedOrders to hold confirm status on reloads
	buildAvailableOrders(item){
		let orders = item;	
		orders = [...new Set(orders['salesordersdetails'].map((i) => {return i}))];
		orders = orders.map((i) => {
			const stagedAlready = this.orderIsStaged(i.orderno, true);
			if(stagedAlready > -1){
				const ord = this.stagedOrders[stagedAlready];
				i.confirmed = ord.confirmed;
				i.labelPrinted = ord.labelPrinted;
				
				if(!i.labelPrinted){
					i.confirmed = false;
				}
			}
			
			return i;
		})
		
		this.availableOrders = orders;
		this.availableOrdersFiltered = this.availableOrders;
		this.focusInput();
	}

	//scan/entry for order selecting (searchbar once prod is loaded)
	scanOrder() {
		const search = this.labelScanRef.value.toUpperCase().trim();

		function buildSimpleSting(ord){
			return `${ord.orderno} ${ord.debtorno} ${ord.deladd1 ?? ''} ${ord.deladd2 ?? ''} ${ord.deladd4 ?? ''} ${ord.deladd5 ?? ''} ${ord.deladd6 ?? ''}`
		}

		this.availableOrdersFiltered =  this.availableOrders.filter((i) => {
			const formatted = buildSimpleSting(i).toUpperCase();
			if(formatted.includes(search)){
				return i;
			}
		})

		if(this.availableOrdersFiltered.length === 1){
			this.stageOrder(this.availableOrdersFiltered[0]);
		}else if(!this.availableOrdersFiltered.length){
			this.errorReporter(search + ' - order not found');
		}

		this.labelScanRef.setValue('');
		this.availableOrdersFiltered = this.availableOrders;

		this.focusInput();
	}


	//secondary scan once an order gets staged to verify fedex tracking number is the orders
	confirmOrder(){
		function barcodeLogic(input, tracknumber){
			let match = false;
			//fedex has it end of the master track after 00
			if(input.includes('00'+ tracknumber.trim())){ match = true; }
			
			//ups is direct match
			if(input == tracknumber.trim()){ match = true; }
			return match;
		}

		const fedexbarcode = this.fedexScanRef.value.trim()
		let requiresbinding = false;
		const bound = false;

		//upc scan section to check quantity------------------------------------------
		//need to scan upc here (4/4 2/2 1/1 - every tire being scanned)
		if(!this.orderToConfirm['skusconfirmed']){
			this.orderToConfirm['skusconfirmed'] = 0;
		}

		
		//get expected of current confirm order & store in confirmingorder
		const skucount =  this.orderToConfirm['details'].reduce((accumulator, currentValue) => {
			return accumulator + Number(currentValue['quantity']);
		},0);
		this.orderToConfirm['skucount'] = skucount;

		//increment scanned skus
		if((this.barcodeMatch(fedexbarcode) && skucount > this.orderToConfirm['skusconfirmed']) || this.clicktoload){
			this.orderToConfirm['skusconfirmed'] += 1;
			if(this.orderToConfirm['skusconfirmed'] == skucount){
				this.fedexScanRef.setValue('');
				this.focusInput();
				return;
			}
		}else if (this.orderToConfirm.skusconfirmed < this.orderToConfirm.skucount){
			this.errorReporter(`"${fedexbarcode}" does not match ${this.currentProduct.stockid} UPC`);
			this.orderToConfirm.hasError = true;
		}


		//end function if recorded upc scans != amount ordered
		if(this.orderToConfirm['skusconfirmed'] !== skucount && !this.clicktoload){
			this.fedexScanRef.setValue('');
			this.focusInput();
			return;
		}else{
			//check if order needs to be binded after qty has been confirmed
			this.orderToConfirm['tracking'].forEach((track) => {
				if(track.bind == 1 && !this.orderToConfirm['bound']){
					requiresbinding = true;
					if(confirm(`Order #${this.orderToConfirm.orderno} requires binding.\n\nConfirm when the tires have been bound.`)){
						this.orderToConfirm['bound'] = true;
					}else{
						this.orderToConfirm['bound'] = false;
					}
				}
			})


		}

		//if binding is reqd and cancelled halt function
		if(requiresbinding && !this.orderToConfirm['bound']){
			return;
		}



		//tracking number scan section--------------------------------------------------
		let confirmedcount = this.orderToConfirm['tracking'].reduce((accumulator, currentValue) => {
			if(currentValue['confirmed'] == true){
				return accumulator + 1;
			}else{
				return accumulator + 0;
			}
		},0);
		
		//increment track number
		let matchfound = false;
		this.orderToConfirm['tracking'].forEach(trk => {
			if(barcodeLogic(fedexbarcode.toUpperCase(), trk['trackingnumber'].toUpperCase())){
				if(!trk['confirmed']){
					this.playAudio('good');
					trk['confirmed'] = true;
					confirmedcount++;
					matchfound = true;
					let type = 'success'
					if(confirmedcount < this.orderToConfirm.tracking.length){
						type = 'warning';
					}
					this.notifier(`Tracking# ${confirmedcount}/${this.orderToConfirm.tracking.length} accepted`, type);
				}
			}
		});



		const allconfirmed = this.orderToConfirm.tracking.length === confirmedcount;
		let match = false;
		// NEEDS BOTH TRACK #S CONFIRMED AND ALL SKUS SCANNED
		if(allconfirmed || this.clicktoload){
			this.stagedOrders.forEach((i) => {
				if(i.orderno == this.orderToConfirm.orderno){
					i.confirmed = true;
					match = true;	
				}
			})
			if(match){
				this.fedexScanRef.setValue('');
				this.packOrder();
				this.currentstep = 'TIRE';
			}
		}else if(!matchfound && !allconfirmed){
			this.errorReporter(`"${fedexbarcode}" does not match order tracking#`);
			this.orderToConfirm.hasError = true;
		}
		
		
		this.fedexScanRef.setValue('');
		this.focusInput();
	}

	checkForTrack(order, input){
		function barcodeLogic(input, tracknumber){
			let match = false;
			//fedex has it end of the master track after 00
			if(input.includes('00'+ tracknumber.trim())){ match = true; }
			//ups is direct match
			if(input == tracknumber.trim()){ match = true; }
			return match;
		}

		let hasMatch = false;
		let proceed = true;
		order.tracking.forEach((trk) => {
			if(barcodeLogic(input.toUpperCase(), trk.trackingnumber.toUpperCase())){
				hasMatch = true;
				//if config for all tracking to load - mark as active load, update trk on match and scroll into view.
				if(this.alltrksload){
					if((this.loadingOrder.orderno != order.orderno) && this.loadingOrder){
						this.playAudio('bad');
						if(confirm(`This tracking number does not belong to order #${this.loadingOrder.orderno}.\n\n Stop loading of current order and switch to this one?`)){
							this.loadingOrder.tracking.map((trk) => trk.confirmed = false);
							const index = this.orderIsStaged(this.loadingOrder.orderno, true);
							this.stagedOrders[index].moreinfo = false;

						}else{
							proceed = false;
						}
					}
					if(proceed){
						this.playAudio('good');
						trk.confirmed = true;
						order.moreinfo = true;
						this.loadingOrder = order;
					}
					const element = document.getElementById(this.loadingOrder.orderno);
					if (element) {
						element.scrollIntoView({ behavior: 'smooth', block: 'start' });
					}
				}
			}
		})

		return hasMatch;
	}


	//for tire upc matches
	barcodeMatch(search){
		let match = [];
		if(this.currentProduct.barcodes){
			match = this.currentProduct.barcodes.filter((i) => {

				let hasmatch = false;
				switch (true) {
				case i.toUpperCase() === search.toUpperCase():
					hasmatch = true;
					break;
				case i.slice(-12).toUpperCase() === search.slice(-12).toUpperCase():
					hasmatch = true;
					break;
				case i.slice(0, 12).toUpperCase() === search.slice(0, 12).toUpperCase():
					hasmatch = true;
					break;
				}
				if(hasmatch){
					return i;
				}
			});
		}
		return match.length ? true : false;
	}


	packOrder(){
		const data = { order: this.orderToConfirm, user:this.user.user.userid };
		const socketdata = { orderno: this.orderToConfirm.orderno, statusid: this.packedStatus };
			
		//mark packed in db - socket to send pick update
		if(this.orderToConfirm['itempick']){
			(this.orderToConfirm['itempick']).forEach((pick) => {
				// this.sendOrderUpdate(pick);
			})
		}
			
		this.ordersService.markStickerOrderPacked(data).subscribe((res) => {
			if(res.status){
				if(res.document.base64){
					const haderror = this.orderToConfirm.hasError;
					this.orderToConfirm = false;
					this.labelToPrint = false;
					this.itemScanRef.setValue('');

					const index = this.orderIsStaged(data.order.orderno, true);
					this.stagedOrders[index].labelPrinted = true
					this.stagedOrders[index].statusid = this.packedStatus;
					this.stagedOrders[index].packedtime = res.packedtime;
					this.stagedOrders[index].packeduserid = res.packeduserid;
					this.stagedOrders[index].shipper_id = this.stagedOrders[index].shipvia;
					this.currentstep = 'Order';

					if(this.packedlabels){
						this.notifier(`printing label for ${data.order.orderno}`);
						this.sendPrint(res.document.base64, 'LABEL');
					}

					//send socket command here to update tv and other users
					this.sendScanSocket(socketdata, 'order');
						
					if(haderror === true){
						this.sendScanSocket('', 'clearerror')
					}

				}else{
					this.errorReporter('Could not print internal label');
				}
			}else{
				this.sendScanSocket([], 'getlast');
			}
		})
	}



	//used to bundle orders together before sending off to socket to be added - remove or add to staged 
	stageOrder(order: any){
		//only allow picked order interaction
		if(!order.picked){
			this.errorReporter(`Order #${order.orderno} is not picked. Please pick before continuing.`);
			return;
		}

		//if already in  another order - notify and reset
		if(this.orderToConfirm && confirm('UN-STAGE ORDER?')){
			this.notifier(`Packing of ${this.orderToConfirm.orderno} reset.`, 'warning');
			this.resetOrderToConfirm();
			return;
		}

		let index = 0;
		let removeat = -1;
		this.stagedOrders.forEach((o) => {
			if(o.orderno == order.orderno){
				removeat = index;
			}
			index++;
		})
		//order not in staged - add it
		if(removeat == -1){
			order.confirmed = false; //step 2
			order.labelPrinted = false; //step 3
			this.stagedOrders.push(order);
			this.orderToConfirm = order;
			this.currentstep = 'STICKER';

			if(this.clicktoload){
				this.orderToConfirm.details.forEach(() => {
					this.confirmOrder();
				})
			}
		}
		//order in staged and has been packed - remove
		if(removeat > -1 && order.orderstatusid === this.packedStatus){
			const unpack = confirm(`Un-Pack ${order.orderno} ?`);
			if(unpack){
				this.unpackOrder(order.orderno);
			}
		//order is loaded
		}else if(removeat > -1 && order.orderstatusid === this.stagedStatus){
			alert(`Order ${order.orderno} is currently loaded to ${order.type} ${order.container ?? 'LIVE LOAD'}. \n\nUn-Load before unpacking.`);
		}

		this.focusInput();
	}

	unpackOrder(orderno: any){
		const index = this.orderIsStaged(orderno, true);
		const order = this.stagedOrders[index];
		if(order){
			const data = { order: order };
			this.ordersService.unpackStickerOrder(data).subscribe((res: any) => {
				//send socket call to remove from dashboard and other devices
				if(res.success){
					this.sendScanSocket(res.order, 'unpack');
					this.stagedOrders.splice(index, 1);
					this.unitsStaged();
				}
			});
		}
	}

	//index finder
	orderIsStaged(orderno, returnIndex = false): any{
		const match = this.stagedOrders.filter((i) => {
			if(i.orderno == orderno){
				return i;
			}
		})
		if(returnIndex){
			if(match.length){
				return this.stagedOrders.indexOf(match[0]);
			}else{
				return -1;
			}
		}else{
			return match.length ? true : false;
		}
	}


	//counts for packed/staged
	unitsStaged(){
		let countpacked = 0;
		let unitspacked = 0;
		let countstaged = 0;
		let unitsstaged = 0;

		this.stagedOrders.forEach((i) => {
			if(this.activeStageType){
				if(i.shipper_id == this.activeStageType.shipper_id){
					if(this.activeStageType.container && this.activeStageType.container == i.container_id){
						if(i.statusid == this.packedStatus){
							countpacked++;
						}else{
							countstaged++;
						}
						i.details.forEach((line) => {
							if(i.statusid == this.packedStatus){
								unitspacked += Number(line.quantity);
							}else{
								unitsstaged += Number(line.quantity);
							}
						})
					}else{
						if(i.statusid == this.packedStatus){
							countpacked++;
						}else{
							countstaged++;
						}
						i.details.forEach((line) => {
							if(i.statusid == this.packedStatus){
								unitspacked += Number(line.quantity);
							}else{
								unitsstaged += Number(line.quantity);
							}
						})
					}
				}
				
			}else{
				if(i.statusid == this.packedStatus){
					countpacked++;
				}else{
					countstaged++;
				}
				i.details.forEach((line) => {
					if(i.statusid == this.packedStatus){
						unitspacked += Number(line.quantity);
					}else{
						unitsstaged += Number(line.quantity);
					}
				})
			}

			
		})
		this.getStagedOrders();
		this.currentCounts =  { 'packed': { 'orders': countpacked, 'units': unitspacked }, 'staged': { 'orders': countstaged, 'units': unitsstaged } };
	}

	focusInput(){
		setTimeout(() => {
			const container = this.mainContent.nativeElement;
			const input = this.searchRef.nativeElement;

			// Focus input (may cause scroll)
			input.focus();

			// Immediately reset scroll position
			if(!this.stageMode){
				this.scrollToTop();
				container.scrollTop = 0;
				container.scrollLeft = 0;
			}
		},500)
	}


	//send order info to socket server - adds, removes, status updates
	sendScanSocket(input:any, type) { 
		let data:any = false;
		switch(type) {
		case 'order':
			data = {
				order: input.orderno,
				status: input.statusid,
				stageduserid: input?.stageduserid,
				stagedtime: input?.stagedtime,
				user: this.user.user.userid,
				container: input.container_id,
				type: 'order'
			}
			break;
		case 'unpack':
			data = {
				order: input.orderno,
				status: input.statusid,
				user: this.user.user.userid,
				type: 'unpack'
			}
			break;
		case 'error':
			data = {
				type: 'err',
				msg: input.msg,
				user: this.user.user.userid
			}
			break;
		case 'oc-started':
			data = {
				'type': 'oc-started',
				'shipper_id':this.activeStageType.shipper_id,
				'shippername':this.activeStageType.shippername,
				'container':this.activeStageType.container,
				'id': `${this.activeStageType.shippername}-${this.activeStageType.container ? this.activeStageType.container : 'live'}`,
				'orders' :input.orders,
				'user': this.user.user.userid
			}
			this.openOcAlert(data);
			break;
		case 'oc-complete':
			data = {
				'type': 'oc-complete',
				'shipper_id':this.activeStageType.shipper_id,
				'shippername':this.activeStageType.shippername,
				'container':this.activeStageType.container,
				'id': `${this.activeStageType.shippername}-${this.activeStageType.container ? this.activeStageType.container : 'live'}`,
				'orders': input.orders,
				'user': this.user.user.userid,
			}
			break;
		case 'config-update':
			data = { type: 'config-update' };
			break;
		case 'clearerror':
			data = { type: 'clearerror' };
			break;
		default:
			if(!data){
				data = { type: 'updatelast' }
			}
			break;
		}
		
		const CHAT_ROOM = 'scanners';
		this.omsService.sendStickerscan({ data, roomName: CHAT_ROOM }, cb => { });
	}


	resetProduct(){
		//if in the process of confirming/printing and backed out to order lookup = remove staged
		this.showSkuTable = false;
		this.currentProduct = false;
		this.itemScanRef.setValue('');
		this.labelScanRef.setValue('');
		this.fedexScanRef.setValue('');
		this.skuSearchRef.setValue('');
		this.stageMode = false;
		this.currentstep = 'TIRE';
		this.focusInput();
	}

	resetOrderToConfirm(){
		const index = this.orderIsStaged(this.orderToConfirm['orderno'], true)
		this.stagedOrders[index].tracking.map((i) => {
			i.confirmed = false;
		})
		this.stagedOrders[index].skusconfirmed = 0;
		this.stagedOrders.splice(index, 1);
		this.orderToConfirm = false;
		this.labelToPrint = false;
	}


	resetOrderProcess(){
		const index = this.orderIsStaged(this.orderToConfirm['orderno'], true)
		if(this.orderToConfirm && (!this.orderToConfirm.labelPrinted || !this.orderToConfirm.confimed)){
			this.stagedOrders[index].tracking.map((i) => {
				i.confirmed = false;
			})
			this.stagedOrders[index].skusconfirmed = 0;
			this.stagedOrders.splice(index, 1);
			this.orderToConfirm = false;
			this.labelToPrint = false;
			this.currentstep = 'TIRE';
		}
		this.focusInput();
	}

	markOrderStaged(){
		const search = this.stageScanRef.value.trim();
		this.stageScanRef.setValue('');		
		let match = [];


		this.stagedOrders.filter((ord) => {
			if(this.checkForTrack(ord, search)){
				match = [ord];
			}
		})

		let confirmedTracks = true;
		match[0].tracking.forEach(trk => {
			if(!trk.confirmed){confirmedTracks = false}
		})


		if(match.length === 1 && ((this.alltrksload && confirmedTracks) || (!this.alltrksload))){
			const ordindex = this.orderIsStaged(match[0].orderno, true);
			if(match[0].statusid == this.stagedStatus){
				if(confirm(`Un-stage #${match[0].orderno} ?`)){
					this.orderToConfirm = match[0];
					this.packOrder();
					this.stagedOrders[ordindex].statusid = this.packedStatus;
					this.stagedOrders[ordindex].container = false;
					this.stagedOrders[ordindex].container_id = false;
					this.stagedOrders[ordindex].moreinfo = false;
					this.stagedOrders[ordindex].tracking.map((trk) => {trk.confirmed = false});
					this.sendScanSocket(this.stagedOrders[ordindex], 'order');
					this.loadingOrder = false;
				}
			}else{
				const data = { order: match[0], user:this.user.user.userid, type: this.activeStageType };
				
				this.ordersService.markStickerOrderStaged(data).subscribe((res) => {
					if(res.status){
						this.notifier(`Order #${res.order.orderno} has been marked for pick-up`);
						this.stagedOrders[ordindex].statusid = this.stagedStatus;
						this.stagedOrders[ordindex].stagedtime = res.order.stagedtime;
						this.stagedOrders[ordindex].stageduserid = res.order.stageduserid;
						this.stagedOrders[ordindex].container = res.order.container_id;
						this.stagedOrders[ordindex].container_id = res.order.container_id;
						this.stagedOrders[ordindex].moreinfo = false;
						this.stagedOrders[ordindex].tracking.map((trk) => {trk.confirmed = false});
						
						this.loadingOrder = false;
						this.sendScanSocket(res.order, 'order');
						this.getStagedOrders();
					}
				});
			}
			
		}else if(!match.length){
			this.errorReporter(search + ' - order not found');
		}

		this.labelScanRef.setValue('');

		this.focusInput();
	}


	//main error report function to display scan errors
	errorReporter(msg) { 
		this.globalSearchService.showNotification(msg,'danger wiggle','top','right');
		this.sendScanSocket({ msg: msg }, 'error');
		this.playAudio('bad');
	}

	//local warning
	notifier(msg, type = 'success'){
		this.globalSearchService.showNotification(msg,type,'top','right');
	}



	//lsitens to socket calls and updates accordingly
	startSocketListener() {
		this.omsService.subscribeToStickerScanResults((err, data: any) => {
			if (data.user !== this.user.user.userid) {
				if(data.type == 'order'){
					this.updateOrderStatus(data);
				}
				if(data.type == 'unpack'){
					const index = this.orderIsStaged(data.order, true);
					this.stagedOrders.splice(index, 1);
					this.unitsStaged();
				}
				if(data.type == 'config-update'){
					this.getConfiguration();
				}
				if(data.type == 'oc-complete'){
					if(data.orders.user == this.user.user.userid){
						this.signing.status = false;
						this.signing.value = false;
						this.pickups = false;
						this.activeStageType = false;
						this.initUser();
						this.stageMode = false;
						this.notifier(`${this.userocdata.shippername} ${this.userocdata.container  != false ? this.userocdata.container : 'LIVE' } CONFIRMED`);
						this.userocdata = false;
						this.modalService.dismissAll();
					}
					this.unitsStaged();
				}
				if(this.view === 'dashboard'){
					if(data.type === 'err'){
						this.playAudio('bad')
						this.showErrorLine(data.msg);
					}
					if(data.type === 'clearerror'){
						this.dismissError();
					}
					if(data.type === 'oc-complete'){
						document.getElementById(data.id)?.classList.remove('ocing');
						this.activeOc = false;
						this.initUser();
					}

					//initaited by user
					//send server req from dashboard
					//send oc-complete back to socket to update user who initiated
					if(data.type === 'oc-started'){
						if(!data.container){ data.container = 'live'; }
						this.activeOc = data;

						if(!this.ocing){
							this.ocing = true;
							if(this.user.user.userid.toUpperCase() === 'TVGUIDE'){ //only let tv guide oc orders...
								this.ordersService.ocStagedStickerOrders(data.orders).subscribe((i) => {
									if(!this.mainprinter){
										this.sendPrint(i.deliverysheet.base64, 'DISPATCH');
										this.sendPrint(i.prints.base64, 'INVOICE');
									}
									
									document.getElementById(data.id)?.classList.remove('ocing');
									this.activeOc = false;
									this.initUser()
									setTimeout(() => {
										this.sendScanSocket({ msg: 'oc-complete', orders: data.orders }, 'oc-complete');
										this.ocing = false;
									}, 2000)
									
								})
							}
							document.getElementById(data.id)?.classList.add('ocing');
						}
						
					}
					if(data.type == 'unpack'){
						this.formatDashboardStaged();
					}

					this.getLastOrders();
				}
			}else{
				this.unitsStaged();
				if(this.view === 'dashboard'){
					this.getLastOrders();
				}
			}
			
		})
		
	}

	//error reporting on dashboard
	showErrorLine(msg: any){
		this.hasError = true;
		this.errorMsg = msg.toUpperCase();
		setTimeout(() => {
			this.errorMsg = false;
			this.hasError = false;
		}, 80000);
	}

	dismissError(){
		this.errorMsg = false;
		this.hasError = false;
	}


	//called upon 'order' received from socket listener
	updateOrderStatus(data: any){
		if(['updatelast', 'err'].includes(data.type)){return false}
		let updated = false;
		this.stagedOrders.forEach((ord) => {
			if(ord.orderno == data.order){
				ord.statusid = data.status;
        		ord.stageduserid = data.stageduserid;
				ord.stagedtime = data.stagedtime;
				ord.container_id = data.container ?? ''
				ord.container = data.container ?? '';
				updated = true;
			}
			if(this.view === 'dashboard'){
				this.formatDashboardStaged();
			}
		})
		if(!updated){
			//singular order call rather than reupdate all
			this.ordersService.getPackedStickerOrder(data.order).subscribe((res: any) => {	
				this.stagedOrders.push(res[0].so[0]);	
				this.unitsStaged();
			});
		}else{
			this.unitsStaged();
		}
	}


	//spilts orders out for tv by shipvia & container
	formatDashboardStaged(){
		const formatted = {};
		const reversed = this.stagedOrders.reverse();
		reversed.forEach((ord) => {
			if(ord.statusid == this.stagedStatus){
				const shipper = this.getShipviaName(ord.shipper_id);
				if(!formatted[shipper]){
					formatted[shipper] = [];
				}
				if(!ord.container_id){
					if(!formatted[shipper]['live']){
						formatted[shipper]['live'] = [];
					}
					formatted[shipper]['live'].push(ord);
				}else{
					if(!formatted[shipper][ord.container_id]){
						formatted[shipper][ord.container_id] = [];
					}
					formatted[shipper][ord.container_id].push(ord);
				}
			}
		})

		this.dashboardStaged = formatted;
	}

	//gets container by index
	containerByIndex(shipper, index){
		return Object.keys(shipper.value)[index];
	}

	//shipper name from id
	getShipviaName(shipper_id){
		const ret = this.allshipvias.find((i) => {return i.shipper_id == shipper_id})
		return ret.shippername;
	}


	//this will handle oc and invoice generation
	confirmPickups() {
		this.pickups = this.getStagedOrders();
		if(!this.pickups){
			this.toggleStageMode();
		}else{
			const orders = this.pickups.map((i) => {return i.orderno + '\n'}).join('').toString();
			if(confirm(`Get courier signature and OC the following ${this.pickups.length} orders?\n\n${orders}`)){
				this.signing.status = true;
			}else{
				this.stageMode = false;
				this.activeStageType = false;
				this.initUser();
				this.resetProduct();
			}
		}
	}


	OCOrders(e: any){
		//event emitted for electric-signature completion
		let oc = false;
		if(e  == false){
			this.signing.status = false;
			this.signing.value = false;
		}else{
			this.signing.status = false;
			this.signing.value = e
			oc = true;
		}

		if(oc){
			const pickups = this.getStagedOrders(this.activeStageType.shipper_id, this.activeStageType.container ?? false);
			const data = { orders: pickups, user: this.user.user.userid, signature: this.signing.value, shipvia: this.activeStageType, printer: this.mainprinter }
			this.sendScanSocket({ msg: 'oc-started', orders: data }, 'oc-started');
		}		
	}


	//get staged orders to confirm -> need to be by stage type id and by containerid
	getStagedOrders(shipperid = false, containerid = false){
		const ret = this.stagedOrders.filter((ord) => {
			let cont = true;
			if(ord.statusid != this.stagedStatus){
				cont = false;
			}
			if(shipperid && cont){
				if(ord.shipper_id !== shipperid){ cont = false; }	
			}
			if(containerid && cont){
				if(ord.container_id !== containerid){ cont = false; }
			}
			if(cont){return ord};
		}) ?? [];
		this.pickupcount = ret.length;
		return ret;
	}

	//in stage mode filter down viewable orders to that of shipper type and container if applicable
	getShipviaOrders(shipperid = false){
		this.resetFilters();
		const ret = this.stagedOrders.filter((ord) => {
			let cont = true;
			if(shipperid && cont){
				if(ord.shipper_id !== shipperid){ cont = false; }	
			}
			//if not in container mode - don't show ords w container 
			if(!this.activeStageType.container && ord.container_id){
				cont = false;
			}
			//if in container mode - show staged orders to that container only - packed isn't assigned a container yet
			if(this.activeStageType.container && ord.statusid == this.stagedStatus){
				cont = ord.container_id !== this.activeStageType.container ? false : cont;
			}
			if(cont){return ord};
		}) ?? [];

		return ret;
	}


	scrollToTop(){
		this.viewportScroller.scrollToPosition([0,0]);
		
	}

	sendPrint(data: [], type){
		const user = this.user.user.userid;
		const printers = this.usersService.getDevicesByType(user, type);
		if (printers && printers.length && data.length) {
			this.omsService.setNewOrder();
			data.forEach(doc => {
				const data = { pdf: doc, user: user, devices: printers }	
				this.omsService.sendPrintCommand({ data, roomName: 'Printers' }, cb => {
					this.omsService.setPrintedOrder();
				})
			});
		}
	}

	playAudio(type: any){	
		let audio: any = false;
		if(type == 'bad'){
			audio = new Audio('/assets/money.mp3');
			for (let index = 0; index < 3; index++) {
				if (audio) {
					setTimeout(() => {
						audio.play();
					}, 1700 * index);
				}
			}
		}else{
			audio = new Audio('/assets/pristine-609.mp3');
			audio.play();
		}	
	}





	togglePicking(){
		this.picking = !this.picking;
	}


	//shipvias with sticker = 1 in shippers_extra
	getStickerShipvias(){
		this.ordersService.getStickerShipvias(true).subscribe((res: any) => {
			this.stickershipvias = res.data.map((i) => {return i.shipper_id});
			this.allshipvias = res.data ?? [];
			if(this.view === 'dashboard'){
				this.formatDashboardStaged();
			}
		});
	}


	//set shipper type for order staging
	setType(shipvia, container){
		this.stagetypeset = false;
		this.activeStageType = shipvia;
		this.showContainerSelection = container ? true : false;
		if(!container){
			this.activeStageType.container = false;
			this.stagedOrders = this.getShipviaOrders(shipvia.shipper_id);
			this.stagedOrders.forEach((ord) => {
				ord['tracking'].map((trk) => {
					trk.confirmed = false;
				});
			});
			this.unitsStaged();
			this.stagetypeset = true;
			this.modalService.dismissAll();
		}
	}

	//new container modal
	addNewContainer(){
		this.modalService.open(this.containerAddModalRef, { ariaLabelledBy: 'modal-basic-title', size: 'xl' }).result.then((result) => {
			if(!this.stagetypeset){
				alert('type not fully set')
			}
		});
	}

	//save container to db and update local data
	saveContainer(shipvia, input){
		const data = { shipvia: shipvia, containerid: input }
		this.ordersService.saveStickerContainer(data).subscribe((res) => {
			if(res.success){
				this.activeStageType = res.data;
				this.activeStageType['containers'] = res.containers;

				if(this.activeStageType){
					this.notifier(`Container saved ${this.activeStageType['shippername'].toUpperCase()} #${this.activeStageType['container_id']}`);
					document.getElementById('containeraddclose')?.click();
				}
			}
		});
	}

	//set container of activeStageType
	setContainer(input){
		this.activeStageType['container'] = input;
		this.stagedOrders = this.getShipviaOrders(this.activeStageType.shipper_id);
		this.unitsStaged();
		this.stagetypeset = true;
		this.modalService.dismissAll();
	}


	//phone view - filtering of orders
	filterOrders(){
		const typeValue = this.ordTypeFilter.value == 'all' ? false : this.ordTypeFilter.value;
		const shipperValue = this.shipperTypeFilter.value == 'all' ? false: this.shipperTypeFilter.value;
		
		if(!typeValue && !shipperValue){
			this.stagedOrders = this.stagedOrdersAll;
		}else{
			this.stagedOrders = this.stagedOrdersAll.filter((i) => {
				switch (true) {
				case typeValue && shipperValue:
					return i.statusid == typeValue && shipperValue == i.shipper_id;
				case typeValue && !shipperValue:
					return i.statusid == typeValue;
				case !typeValue && shipperValue:
					return i.shipper_id == shipperValue;
				default:
					return false;
				}
			})
		}
		this.unitsStaged();
	}


	openOcAlert(ocdata){
		this.userocdata = ocdata;
		this.modalService.open(this.ocAlertModal , { ariaLabelledBy: 'modal-basic-title', size: 'xl',  backdrop: 'static', keyboard: false }).result.then((result) => {

		}, (reason) => {
			this.userocdata = false
		});
	}


	//phone view - reset of filters
	resetFilters(){
		this.ordTypeFilter.setValue('all');
		this.shipperTypeFilter.setValue('all');
		this.showFilter = false;
	}

	//dblclick on order block when packed or staged
	moreInfo(ord){
		ord.moreinfo = ord.moreinfo ? false : true;
	}


	//for picking orders
	sendOrderUpdate(orderupdate: any) {
		const data = orderupdate
		if (data) {
			this.omsService.sendOrderPickUpdate({ data, roomName: 'OrderBoard' }, cb => {
				this.globalSearchService.showNotification(`Order ${orderupdate.orderno} marked as picked`, 'success', 'top', 'right');
			});
		}
	}

	admin_confirm(shipper, type){
		if(confirm(`OC ${shipper.key} ${type.key} ?`)){
			const data = {
				user: this.user.user.userid,
				orders: type.value,
				shipvia: shipper.key,
				container: type.key
			}
			console.log('data to oc :', data);
		}
	}
}
